//储存 data数据
export function objData() {
    let data = {
        bShowMap: false, // 选择地址弹窗
        arrCity: [], // 三级联动数据
        bSystemTips: false, //选择系统
        oXnUserInfo: {}, // 信息
        nWindUid: 0, // 业主id
        nCityId: null, // 城市id
        nLng: null, // 经度
        nLat: null, // 纬度
        oAddress: {
            name: "",
        }, // 地址
        nArea: "", // 面积
        nFloor: "", // 层高
        nFamiliesNum: "", // 成员人数
        editFloorContentPopupShow: false, // 编辑楼层内容弹窗
        areaPopupShow: false, // 输入面积弹窗
        bConfirmPopupShow: false, // 删除确认弹窗
        bFloorPopupShow: false, // 地下室选择弹窗
        bNoOftenPopupShow: false, // 非频繁使用空间弹窗
        areaPopupInputVal: "", // 输入面积弹窗输入框值
        oTags: {}, // 需要修改面积的tags
        deleteIndex: null, // 要删除的索引
        // 装修情况
        oRenovationInfo: {
            checked: [],
            items: [],
            id: 30,
            name: "装修情况",
        },
        // 用户性别
        oGenderInfo: {
            checked: [],
            items: [],
            id: 40,
            name: "用户性别",
        },
        // 房屋保温情况 - 写死
        // 外墙保温
        oExteriorInfo: {
            id: null,
            is_compare: 0, // 是否对比核心 0否1是
            is_fix: 0, //是否复合标签 0否1是
            is_num: 1, //是否校验数值 0否1是
            is_report: 1, // 是否报告展示 0否1是
            is_require: 1, // 是否报告必选 0否1是
            name: "外墙保温",
            checked: [],
            items: [
                {
                    id: 1,
                    is_default: 0,
                    max_val: 1,
                    min_val: 1,
                    name: "有",
                },
                {
                    id: 0,
                    is_default: 0,
                    max_val: 1, // 校验数值为1时有效，最大值
                    min_val: 1, // 校验数值为1时有效，最小值
                    name: "无",
                },
            ],
        },
        //双层隔热窗
        oHeatInsulationInfo: {
            id: null,
            is_compare: 0, // 是否对比核心 0否1是
            is_fix: 0, //是否复合标签 0否1是
            is_num: 1, //是否校验数值 0否1是
            is_report: 1, // 是否报告展示 0否1是
            is_require: 1, // 是否报告必选 0否1是
            name: "双层隔热窗",
            checked: [],
            items: [
                {
                    id: 2,
                    is_default: 0,
                    max_val: 1,
                    min_val: 1,
                    name: "有",
                },
                {
                    id: 1,
                    is_default: 0,
                    max_val: 1, // 校验数值为1时有效，最大值
                    min_val: 1, // 校验数值为1时有效，最小值
                    name: "无",
                },
            ],
        },
        //房屋类型
        oPropertyTypeInfo: {
            checked: [],
            items: [],
            id: 34,
            name: "房屋类型",
        },
        bDelFloorPopupShow: false, //删除楼层弹窗
        nHuoseType: null,
        //户型概况
        oHouseTypeInfo: {
            name: "户型概况",
            activeIndex: 0,
            tabList: [],
        },
        // 对标系统
        oPicker: {
            colorConfirm: "rgba(33, 51, 102, 1)",
        },
        // 对标系统列表
        arrSystemList: [],
        // 选中的对标系统
        sSelectSystemValue: { value: "", id: null },
        nSelectSystemIndex: "",
        //家庭成员概况
        oMemberFamilyInfo: {
            checked: [],
            items: [],
            id: 36,
            name: "家庭成员概况",
        },
        //居家作息
        oAtHomeInfo: {
            checked: [],
            items: [],
            id: 37,
            name: "居家作息",
        },
        // 个性需求
        oIndividualNeedsInfo: {
            checked: [],
            items: [],
            id: 38,
            name: "个性需求",
        },
        // 初始配置数据
        oConfigInfo: {},
        // 编辑楼层内容弹窗数据
        arrEditFloorContent: {
            activeIndex: 0,
            floor: [], // 楼层
            allTagContent: [], // 下面全部标签内容
        },
        // 楼层弹窗数据
        arrFloorNumList: [
            {
                type: 1,
                name: "地面楼层",
                checked: [],
                tags: [
                    {
                        name: "一层",
                        room: 1,
                    },
                    {
                        name: "二层",
                        room: 2,
                    },
                    {
                        name: "三层",
                        room: 3,
                    },
                    {
                        name: "四层",
                        room: 4,
                    },
                ],
            },
            {
                type: 2,
                name: "地下室",
                checked: [],
                tags: [
                    {
                        name: "地下室一层",
                        room: -1,
                    },
                    {
                        name: "地下室二层",
                        room: -2,
                    },
                ],
            },
        ],
        // 非频繁使用
        arrNoOftenTagList: [{ tags: [] }],
        // 页面高度
        originalHeight: null,
        bShowBox: false,
    }
    return data
}
